import { useCostTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setCostSelectedEpics, setCostSelectedTeams } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListEpics } from '../../components/filters-list/filters-list-epics';
import { FiltersListTeams } from '../../components/filters-list/filters-list-teams';
import { useCostTeams } from '../cost-tab.hooks';
import { CostMode } from '../cost-tab.type';
import { useFilteredEpics } from './filters.hooks';

export const FiltersList = () => {
  const mode = useCostTabStore((state) => state.mode);

  const epics = useFilteredEpics();
  const selectedEpics = useCostTabStore((state) => state.selectedEpics);

  const teams = useCostTeams();
  const selectedTeams = useCostTabStore((state) => state.selectedTeams);

  switch (mode) {
    case CostMode.ContributingEpics:
      return <FiltersListEpics epics={epics} selectedEpics={selectedEpics} onSelectEpics={setCostSelectedEpics} />;
    case CostMode.ContributingTeams:
      return <FiltersListTeams teams={teams} selectedTeams={selectedTeams} onSelectTeams={setCostSelectedTeams} />;
    default:
      return null;
  }
};
